import React from 'react';
const rows = [{
  s: 'Primera noche de crisis',
  no: 'Mirás el techo hasta las 4 AM',
  yes: 'Kit 2 AM: protocolo listo en 5 min'
}, {
  s: 'La mente no para',
  no: 'Más scroll, más miedo',
  yes: 'Neuro-Dump vacía la mente en 15 min'
}, {
  s: 'Pensamientos intrusivos',
  no: 'Improvisás y el loop gana',
  yes: '40 respuestas listas para usar'
}, {
  s: 'Instalar el hábito',
  no: 'Lo hacés 3 días y lo abandonás',
  yes: 'Planner 14 noches te lleva de la mano'
}, {
  s: 'Entender por qué pasa',
  no: 'Dr. Google con peores escenarios',
  yes: '30 módulos de neurociencia aplicada'
}, {
  s: 'Crisis de vida real',
  no: 'El sistema colapsa',
  yes: 'Protocolo Avanzado de 90 Días'
}, {
  s: 'Medir el progreso',
  no: 'Creo que mejoro... o no',
  yes: 'Trackers mensuales con métricas reales'
}];
export function ComparisonTable() {
  return <section className="bg-cream py-12 md:py-24 px-4" data-id="element-150">
      <div className="max-w-4xl mx-auto text-center" data-id="element-151">
        <h2 className="font-display font-bold text-navy text-[28px] md:text-[36px] mb-4" data-id="element-152">
          ¿Cuánto cuesta NO tenerlo?
        </h2>
        <p className="text-taupe font-sans mb-8 md:mb-12 text-sm md:text-base" data-id="element-153">
          La próxima noche difícil puede ser diferente.
        </p>

        <div className="rounded-xl overflow-hidden shadow-sm border border-sage-light/20" data-id="element-154">
          {/* Header Row */}
          <div className="grid grid-cols-[1fr_60px_60px] md:grid-cols-3 bg-sage text-cream-white font-sans font-bold text-[10px] md:text-sm" data-id="element-155">
            <div className="p-4 md:p-6 text-left uppercase tracking-wider" data-id="element-156">
              Situación
            </div>
            <div className="flex items-center justify-center border-l border-white/10" data-id="element-157">
              SIN
            </div>
            <div className="flex items-center justify-center border-l border-gold/30 bg-sage/90" data-id="element-158">
              CON
            </div>
          </div>

          <div className="divide-y divide-sage-light/10" data-id="element-159">
            {rows.map((row, i) => <div key={i} className={`grid grid-cols-[1fr_60px_60px] md:grid-cols-3 font-sans text-[11px] md:text-sm ${i % 2 === 0 ? 'bg-white' : 'bg-cream'}`} data-id="element-160">
                <div className="p-3 md:p-6 text-left font-medium text-[#2D2D2D] flex items-center" data-id="element-161">
                  {row.s}
                </div>
                <div className="flex items-center justify-center border-l border-sage-light/5 text-center px-1" data-id="element-162">
                  <span className="text-terracotta md:mr-2" data-id="element-163">❌</span>
                  <span className="hidden md:inline text-taupe italic text-xs" data-id="element-164">
                    {row.no}
                  </span>
                </div>
                <div className="flex items-center justify-center border-l border-gold/20 bg-gold/5 md:bg-transparent font-medium md:border-l-[3px] md:border-gold" data-id="element-165">
                  <span className="text-sage md:mr-2" data-id="element-166">✅</span>
                  <span className="hidden md:inline text-[#2D2D2D] text-xs" data-id="element-167">
                    {row.yes}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-display italic text-sage text-[20px] md:text-[22px] mt-10 md:mt-12" data-id="element-168">
          No estás solo/a en esto. 💛
        </p>
      </div>
    </section>;
}